// Generated by ts-to-zod
import {z} from "zod";

export const mantineAreaChartPropsSchema = z.object({
	h: z.number().optional(),
});
